import { APIService } from "../apiService";
import { AuthenticationService } from "../authenticationService";
import { PaginatedTransferOrders, TransferOrder } from "src/types";
import {
  GetTransferOrdersQueryParams,
  PostTransferOrdersManualRequestBody,
  PostTransferOrdersManualResponse
} from "src/types/api";

class TransferOrderAPIService extends APIService {
  constructor(authenticationService: AuthenticationService) {
    super(authenticationService, "/v1/transfer-orders");
  }

  async getTransferOrders(queryParams: GetTransferOrdersQueryParams): Promise<PaginatedTransferOrders> {
    return await this.jwtRequest("GET", undefined, undefined, queryParams);
  }

  async getTransferOrderById(transferOrderId: string): Promise<TransferOrder> {
    const pathParam = encodeURIComponent(transferOrderId);
    const path = `/${pathParam}`;
    return await this.jwtRequest("GET", path);
  }

  async postTransferOrdersManual(
    requestBody: PostTransferOrdersManualRequestBody
  ): Promise<PostTransferOrdersManualResponse> {
    const path = `/manual`;
    return await this.jwtRequest("POST", path, requestBody);
  }
}

export { TransferOrderAPIService };
